import {
  Autocomplete,
  Box,
  InputAdornment,
  styled,
  TextField,
} from '@mui/material';
import React, { useContext, useEffect, useRef, useState } from 'react';
import GlobalContext from '../context/globalContext';
import SearchIcon from '@mui/icons-material/Search';
import NotFound from '../components/NotFound/NotFoundPage';
import { useLazyQuery, useQuery } from '@apollo/client';
import { useSnackbar } from 'notistack';
import {
  GET_COVERAGE_BY_AFFILIATE_UNAUTH,
  GET_DOWNLOAD_LINK_UNAUTH,
  GET_AFFILIATE_LOGO_URL,
  GET_PRICELIST_DATA,
} from '../services/PriceTransparencyQueries/PriceTransparencyService';
import { SimpleBackdrop } from '../components/SimpleBackdropComponent/SimpleBackdrop';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import Tab from '@mui/material/Tab';
import CoveragePLTableAndSeach from '../components/CoveragePriceListComponent/CoveragePLTableAndSeach';
import SecondaryBtnComponent from '../components/buttonComponent/SecondaryBtnComponent';
import { DownloadRawFile } from '../shared/helper';
import {
  IMAGE_ALTERNATE_TEXT,
  PRICE_LIST,
  PRICE_LIST_HEADINGS,
  OUT_NET_PRICE_LIST_HEADINGS,
} from '../shared/Strings';
import Pagination from '@mui/material/Pagination';
import PriceListSearchBox from '../components/SearchBar/PriceListSearchBox';
import PriceListConfirmationModal from '../components/ConfirmationModal/PriceListConfirmationModal';
import { ACTIVE_PRICE_LIST_PAGE } from '../shared/constants';
import { Backdrop, CircularProgress } from '@mui/material';
import { removeExtraProperty } from '../shared/helper';
import SearchFilters from '../components/SearchBar/SearchFilters';
import ReusableChip from '../components/ReusableChip/ReusableChip';
import PriceListFlyout from '../components/ServiceFlyout/PriceListFlyout';


const paginationStyle = {
  display: 'flex',
  justifyContent: 'center',
  margin: '10px 0px',
};

const ActivePlansPriceList = () => {
  const { activePlansPriceList } = useContext(GlobalContext);
  const [coverageData, setCoverageData] = useState([]);
  const [priceListData, setPriceListData] = useState([]);
  const [value, setValue] = useState(null);
  const [priceListClick, setPriceListClick] = useState(false);
  const [tabValue, setTabValue] = useState('1');
  const [tableHeading, setTableHeading] = useState([]);
  const [priceListTableData, setPriceListTableData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [offset, setOffset] = useState(0);
  const [modifierMenu, setModifierMenu] = useState([]);
  const [modifier, setModifier] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageNumbers, setPageNumbers] = useState();
  const [fileCategory, setFileCategory] = useState();
  const [searchValue, setSearchValue] = useState('');
  const [link, setLink] = useState(null);
  const [open, setOpen] = useState(false);
  const [gridLoad, setGridLoad] = useState(false);
  const [invokeLink, setInvokeLink] = useState(false);
  const [downloadFlag, setDownloadFlag] = useState(0);
  const [startDownload, setStartDownload] = useState(false);
  const [downloadButtonClick, setDownloadButtonClick] = useState(false);
  const [hyperlinkClick, setHyperlinkClick] = useState(false);
  const [flyoutData, setFlyoutData] = useState();
  const [outNetworkFlyout, setOutnetworkFlyoutData] = useState();
  const [openFlyout, setOpenFlyout] = useState(false);
  const [name, setName] = useState('');
  const [code, setCode] = useState('');
  const [npiCode, setNpiCode] = useState('');
  const [active, setActive] = useState(false);
  const payerUrl = window.location.href.split('/')[2];
  const postPerPage = 8;

  const lastIndex = currentPage * postPerPage;
  const firstIndex = lastIndex - postPerPage;

  const handleClose = () => {
    setOpen(false);
  };

  const handleOpen = e => {
    e.preventDefault();
    setOpen(true);
    setDownloadButtonClick(true);
  };

  const affiliateDnsName = window.location.href.split('/')[2].split('-')[0];
  const bacShoppingLink = window.location.href.replace(
    'activeplanspricelist',
    'find-care'
  );

  const proceedDownloadClick = () => {
    setStartDownload(true);
    fetchDownloadLink({
      variables: {
        planId: value ? value.priceListId : coverageData[0].priceListId,
        fileCategory: 'IN_NETWORK_RATE',
      },
    });
  };

  useEffect(() => {
    if (link && startDownload) {
      setOpen(false);
      DownloadRawFile(link, payerUrl);
      setStartDownload(false);
    }
  }, [link, payerUrl, startDownload]);

  const { enqueueSnackbar } = useSnackbar();

  const { data: imageUrl } = useQuery(GET_AFFILIATE_LOGO_URL, {
    variables: { affiliateDnsName: affiliateDnsName },
  });

  const { loading } = useQuery(GET_COVERAGE_BY_AFFILIATE_UNAUTH, {
    fetchPolicy: 'cache-and-network',
    onError: err => {
      enqueueSnackbar(PRICE_LIST.ON_ERROR_TEXT.WENT_WRONG_TEXT, {
        variant: 'error',
      });
    },
    onCompleted: res => {
      const data = res?.getAllCoverageByAffiliateUnauth;
      const coverageDataLocal = data.map(
        ({ name, id, planId: groupId, ...rest }) => {
          return {
            label: `${name} (${groupId})`,
            ...rest,
            priceListId: id,
            groupId: groupId,
            name: name,
          };
        }
      );
      setCoverageData(coverageDataLocal);
    },
  });

  const [fetchDownloadLink, fetchDownloadLinkCall] = useLazyQuery(
    GET_DOWNLOAD_LINK_UNAUTH,
    {
      fetchPolicy: 'cache-and-network',
      onError: err => {},
      onCompleted: res => {
        const data = res.getPriceListFileLinkUnauth?.link;
        setLink(data);
      },
    }
  );

  const [fetchPriceListById, fetchPriceListByIdCall] = useLazyQuery(
    GET_PRICELIST_DATA,
    {
      fetchPolicy: 'cache-and-network',
      onError: err => {
        clearAllData();
        setInvokeLink(true);
        setDownloadFlag(prevValue => prevValue + 1);
      },
      onCompleted: res => {
        const response = res.getPriceListDocument;
        setPriceListData(removeExtraProperty(response));
        setInvokeLink(true);
        setDownloadFlag(prevValue => prevValue + 1);
        setGridLoad(true);
      },
    }
  );

  useEffect(() => {
    setPageNumbers(Math.ceil(priceListData?.length / postPerPage));
  }, [priceListData]);

  useEffect(() => {
    if (!priceListData.length && invokeLink) {
      downloadFlag === 1 &&
        fetchDownloadLink({
          variables: {
            planId: value ? value.priceListId : coverageData[0].priceListId,
            fileCategory: 'IN_NETWORK_RATE',
          },
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [invokeLink, priceListData, downloadFlag]);

  useEffect(() => {
    if (priceListData !== null && priceListData.length > 0) {
      setIsLoading(true);
      let keysArray = [];
      let valueArray = [];
      let heading = [];

      priceListData.slice(firstIndex, lastIndex).forEach((da, index) => {
        for (var key in da) {
          if (!keysArray.includes(key)) {
            keysArray.push(key);
            heading.push(key);
          }
        }
        valueArray[index] = da = {
          ...da,
        };
      });

      for (let item of valueArray) {
        if (fileCategory == 'out') {
          item.allowedAmount = item?.allowedAmount?.min === item?.allowedAmount?.max ? `${item?.allowedAmount?.min}` : `${item?.allowedAmount?.min} - ${item?.allowedAmount?.max}`;
        } else {
          item.negotiatedRate = item.negotiatedRate.min === item.negotiatedRate.max ? `${item.negotiatedRate.min}` : `${item.negotiatedRate.min} - ${item.negotiatedRate.max}`;
        }
      }

      if (fileCategory == 'in') {
        heading = heading.filter(item => PRICE_LIST_HEADINGS.includes(item));
      } else {
        heading = heading.filter(item =>
          OUT_NET_PRICE_LIST_HEADINGS.includes(item)
        );
      }

      // heading = heading.filter(item => {
      //   if(fileCategory == 'out') {
      //     OUT_NET_PRICE_LIST_HEADINGS.includes(item)
      //   } else {
      //     PRICE_LIST_HEADINGS.includes(item)
      //   }
      // }
      // );

      setTableHeading(heading);
      setPriceListTableData(valueArray);
    }
  }, [priceListData, firstIndex, lastIndex]);

  useEffect(() => {
    if (priceListTableData.length) {
      setIsLoading(false);
    }
  }, [priceListTableData, isLoading]);

  const onViewPriceListClick = () => {
    // make service call to fetch pricelist
    setPriceListClick(true);
    setDownloadFlag(0);
    setLink(null);
    setHyperlinkClick(false);
    setDownloadButtonClick(false);
    if (activePlansPriceList?.IN_NETWORK_RATE === true) {
      setFileCategory('in');
      fetchPriceListById({
        variables: {
          reqdata: {
            planId: value
              ? value.priceListId.toString()
              : coverageData[0].priceListId.toString(),
            fileCategory: 'in',
            serviceName: name.toUpperCase(),
            providersNpi: npiCode,
            billingCode: code,
          },
        },
      });
      setTabValue('1');
    } else if (activePlansPriceList?.OUT_OF_NETWORK === true) {
      setFileCategory('out');
      fetchPriceListById({
        variables: {
          reqdata: {
            planId: value
              ? value.priceListId.toString()
              : coverageData[0].priceListId.toString(),
            fileCategory: 'out',
            serviceName: name.toUpperCase(),
            providersNpi: npiCode,
            billingCode: code,
          },
        },
      });
      setTabValue('2');
    } else if (activePlansPriceList?.PRESCRIPTION_DRUG === true) {
      setFileCategory('PRESCRIPTION_DRUG');
      fetchPriceListById({
        variables: {
          reqdata: {
            planId: value
              ? value.priceListId.toString()
              : coverageData[0].priceListId.toString(),
            fileCategory: 'PRESCRIPTION_DRUG',
            serviceName: name.toUpperCase(),
            providersNpi: npiCode,
            billingCode: code,
          },
        },
      });
      setTabValue('3');
    } else if (
      !activePlansPriceList?.PRESCRIPTION_DRUG &&
      !activePlansPriceList?.IN_NETWORK_RATE &&
      !activePlansPriceList?.OUT_OF_NETWORK
    ) {
      setFileCategory('in');
      fetchPriceListById({
        variables: {
          reqdata: {
            planId: value
              ? value.priceListId.toString()
              : coverageData[0].priceListId.toString(),
            fileCategory: 'in',
            serviceName: name.toUpperCase(),
            providersNpi: npiCode,
            billingCode: code,
          },
        },
      });
      setTabValue('1');
    }
  };

  const handleOpenFlyout = () => {
    setOpenFlyout(true);
  };

  const closeFlyout = () => {
    setModifier(null);
    setModifierMenu([]);
    setOpenFlyout(false);
  };

  const onItemView = item => {
    const data = { ...item };
    setFlyoutData(data);
    outNetworkFlyout == undefined && setOutnetworkFlyoutData(data);
    handleOpenFlyout();
  };

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
    setCurrentPage(1);
    if (newValue === '1') {
      setFileCategory('in');
      setSearchValue('');
      if (name === '' && npiCode === '' && code === '') {
        setPriceListData([]);
        setPriceListTableData([]);
      } else {
        fetchPriceListById({
          variables: {
            reqdata: {
              planId: value
                ? value.priceListId.toString()
                : coverageData[0].priceListId.toString(),
              fileCategory: 'in',
              serviceName: name.toUpperCase(),
              providersNpi: npiCode,
              billingCode: code,
            },
          },
        });
      }
    } else if (newValue === '2') {
      setFileCategory('out');
      setSearchValue('');
      if (name === '' && npiCode === '' && code === '') {
        setPriceListData([]);
        setPriceListTableData([]);
      } else {
        fetchPriceListById({
          variables: {
            reqdata: {
              planId: value
                ? value.priceListId.toString()
                : coverageData[0].priceListId.toString(),
              fileCategory: 'out',
              serviceName: name.toUpperCase(),
              providersNpi: npiCode,
              billingCode: code,
            },
          },
        });
      }
    } else if (newValue === '3') {
      setFileCategory('PRESCRIPTION_DRUG');
      setSearchValue('');
      setOffset(0);
      fetchPriceListById({
        variables: {
          reqdata: {
            planId: value
              ? value.priceListId.toString()
              : coverageData[0].priceListId.toString(),
            fileCategory: 'PRESCRIPTION_DRUG',
            serviceName: '',
            providersNpi: '',
            billingCode: '',
          },
        },
      });
    }
  };

  const handleSelectName = () => {
    setName(name);
  };

  const handleDeleteName = () => {
    setName('');
    setCurrentPage(1);
    if (code === '' && npiCode === '') {
      setPriceListData([]);
      setPriceListTableData([]);
    } else {
      fetchPriceListById({
        variables: {
          reqdata: {
            planId: value
              ? value.priceListId.toString()
              : coverageData[0].priceListId.toString(),
            fileCategory: fileCategory,
            serviceName: '',
            providersNpi: npiCode,
            billingCode: code,
          },
        },
      });
    }
  };

  const handleSelectCode = () => {
    setCode(code);
  };

  const handleDeleteCode = () => {
    setCode('');
    setCurrentPage(1);
    if (name === '' && npiCode === '') {
      setPriceListData([]);
      setPriceListTableData([]);
    } else {
      fetchPriceListById({
        variables: {
          reqdata: {
            planId: value
              ? value.priceListId.toString()
              : coverageData[0].priceListId.toString(),
            fileCategory: fileCategory,
            serviceName: name.toUpperCase(),
            providersNpi: npiCode,
            billingCode: '',
          },
        },
      });
    }
  };

  const handleSelectNpiCode = () => {
    setNpiCode(npiCode);
  };

  const handleDeleteNpiCode = () => {
    setNpiCode('');
    setCurrentPage(1);
    if (name === '' && code === '') {
      setPriceListData([]);
      setPriceListTableData([]);
    } else {
      fetchPriceListById({
        variables: {
          reqdata: {
            planId: value
              ? value.priceListId.toString()
              : coverageData[0].priceListId.toString(),
            fileCategory: fileCategory,
            serviceName: name.toUpperCase(),
            providersNpi: '',
            billingCode: code,
          },
        },
      });
    }
  };

  const onFilterSubmit = (filterName, filterNpiCode, filterCode) => {
    setActive(false);
    setCurrentPage(1);
    if (filterName === '' && filterNpiCode === '' && filterCode === '') {
      setPriceListData([]);
      setPriceListTableData([]);
    } else {
      fetchPriceListById({
        variables: {
          reqdata: {
            planId: value
              ? value.priceListId.toString()
              : coverageData[0].priceListId.toString(),
            fileCategory: fileCategory,
            serviceName: filterName.toUpperCase(),
            providersNpi: filterNpiCode,
            billingCode: filterCode,
          },
        },
      });
    }
  };

  const clearAllData = () => {
    setName('');
    setCode('');
    setNpiCode('');
    setFileCategory();
    setGridLoad(false);
    setDownloadFlag(0);
    setLink(null);
    setHyperlinkClick(false);
    setDownloadButtonClick(false);
    setPriceListData([]);
    setPriceListTableData([]);
    setTableHeading([]);
    setPriceListClick(false);
    setCurrentPage(1);
    setActive(false);
  };

  const StyledTab = styled(props => <Tab disableRipple {...props} />)(
    ({ theme }) => ({
      textTransform: 'none',
    })
  );

  if (
    (fetchPriceListByIdCall.loading ||
      loading ||
      fetchDownloadLinkCall.loading) &&
    !gridLoad
  ) {
    return (
      <Backdrop style={{ zIndex: 2000, color: '#fff' }} open={true}>
        <CircularProgress color="inherit" />
      </Backdrop>
    );
  }

  return (
    <>
      <Box
        sx={{
          minHeight: '100vh',
          display: 'flex',
          justifyContent: 'center',
          background: '#ffffff',
        }}>
        <Box
          sx={{
            width: { sm: '95%', xs: '98%', md: '95%', lg: '95%' },
            maxWidth: '1800px',
            background: '#ffffff',
          }}
          display="flex"
          flexDirection="column"
          gap="8px">
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              flexDirection: { xs: 'column', sm: 'row' },
              gap: { xs: 0, sm: 10, md: 15 },
              marginTop: '32px',
            }}>
            <Box
              component="img"
              sx={{
                height: 80,
                // width: { sm: 250, xs: 200 },
                mt: 1,
              }}
              alt={IMAGE_ALTERNATE_TEXT.AFFILIATE_LOGO}
              src={imageUrl?.getAffiliateLogoURLUnauth?.imageUrl}
            />

            {coverageData.length > 1 ? (
              <Box display="flex" gap="24px">
                <Autocomplete
                  disablePortal
                  id="coverage-search"
                  value={value}
                  onChange={(event, newValue) => {
                    setValue(newValue);
                    if (!newValue) {
                      clearAllData();
                    }
                  }}
                  options={coverageData}
                  sx={{ width: { sm: 300, xs: 150 } }}
                  renderInput={params => (
                    <TextField
                      sx={{ bgcolor: '#fff' }}
                      {...params}
                      placeholder={PRICE_LIST.SELECT_PLAN}
                      size="small"
                      InputProps={{
                        ...params.InputProps,
                        startAdornment: (
                          <>
                            <InputAdornment position="start">
                              <SearchIcon />
                            </InputAdornment>
                          </>
                        ),
                      }}
                    />
                  )}
                />
                {/* <BtnComponent
                  title={PRICE_LIST.VIEW_PRICE_LIST}
                  sx={{ height: '38px' }}
                  disabled={!value}
                  onClick={onViewPriceListClick}
                /> */}
              </Box>
            ) : // : !link ? (
            //   coverageData.length === 1 && (
            //     <Typography variant="h3">{coverageData[0].label}</Typography>
            //   )
            // ) : gridLoad ? (
            //   <Typography variant="h3">{coverageData[0].label}</Typography>
            // )
            null}
          </Box>
          <TabContext value={tabValue}>
            {/* {link && downloadFlag === 1 ? (
              hyperlinkClick ? null : downloadButtonClick ? (
                <Box
                  sx={{
                    display: 'flex',
                    width: '100%',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    alignSelf: 'flex-start',
                    flexDirection: { sm: 'row', xs: 'column' },
                    gap: { xs: '20px' },
                  }}>
                  <Box
                    sx={{
                      mt: 3,
                      borderColor: 'divider',
                      alignSelf: 'flex-start',
                    }}>
                    <TabList onChange={handleTabChange}>
                      {activePlansPriceList?.IN_NETWORK_RATE ||
                      (!activePlansPriceList?.OUT_OF_NETWORK &&
                        !activePlansPriceList?.PRESCRIPTION_DRUG) ? (
                        <StyledTab
                          label={PRICE_LIST.IN_NETWORK_RATE}
                          value="1"
                        />
                      ) : null}
                      {activePlansPriceList?.OUT_OF_NETWORK ? (
                        <StyledTab
                          label={PRICE_LIST.OUT_OF_NETWORK}
                          value="2"
                        />
                      ) : null}
                      {activePlansPriceList?.PRESCRIPTION_DRUG ? (
                        <StyledTab
                          label={PRICE_LIST.PRESCRIPTION_DRUG}
                          value="3"
                        />
                      ) : null}
                    </TabList>
                  </Box>
                  <SecondaryBtnComponent
                    // disabled={
                    //   priceListData === null || priceListData.length < 1
                    // }
                    title={PRICE_LIST.DOWNLOAD}
                    sx={{ height: '38px' }}
                    onClick={handleOpen}
                  />
                </Box>
              ) : null */}
            {/* ) : */}
            {gridLoad ? (
              <Box
                sx={{
                  display: 'flex',
                  width: '100%',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  alignSelf: 'flex-start',
                  flexDirection: { sm: 'row', xs: 'column' },
                  gap: { xs: '20px' },
                }}>
                <Box
                  sx={{
                    mt: 3,
                    borderColor: 'divider',
                    alignSelf: 'flex-start',
                  }}>
                  <TabList onChange={handleTabChange}>
                    {activePlansPriceList?.IN_NETWORK_RATE ||
                    (!activePlansPriceList?.OUT_OF_NETWORK &&
                      !activePlansPriceList?.PRESCRIPTION_DRUG) ? (
                      <StyledTab label={PRICE_LIST.IN_NETWORK_RATE} value="1" />
                    ) : null}
                    {activePlansPriceList?.OUT_OF_NETWORK ? (
                      <StyledTab label={PRICE_LIST.OUT_OF_NETWORK} value="2" />
                    ) : null}
                    {activePlansPriceList?.PRESCRIPTION_DRUG ? (
                      <StyledTab
                        label={PRICE_LIST.PRESCRIPTION_DRUG}
                        value="3"
                      />
                    ) : null}
                  </TabList>
                </Box>
                <SecondaryBtnComponent
                  title={PRICE_LIST.DOWNLOAD}
                  sx={{ height: '38px' }}
                  onClick={handleOpen}
                />
              </Box>
            ) : null}
            <Box>
              {/* {link && downloadFlag === 1 ? (
                hyperlinkClick ? null : downloadButtonClick ? (
                  <>
                    <div style={{ marginTop: '20px', marginBottom: '40px' }}>
                      <SearchFilters
                        active={active}
                        setActive={setActive}
                        name={name}
                        setName={setName}
                        handleSelectName={handleSelectName}
                        code={code}
                        setCode={setCode}
                        handleSelectCode={handleSelectCode}
                        npiCode={npiCode}
                        setNpiCode={setNpiCode}
                        handleSelectNpiCode={handleSelectNpiCode}
                        onFilterSubmit={onFilterSubmit}
                      />
                    </div>
                    <div
                      style={{
                        display: 'flex',
                        marginTop: '80px',
                        // marginBottom: '20px',
                        gap: '8px 8px',
                        flexWrap: 'wrap',
                      }}>
                      {name.length > 0 && !active ? (
                        <ReusableChip
                          chipType="Service name"
                          handleDeleteSelectedFields={handleDeleteName}
                          selectedFields={name}
                        />
                      ) : null}
                      {code.length > 0 && !active ? (
                        <ReusableChip
                          chipType="Billing code"
                          handleDeleteSelectedFields={handleDeleteCode}
                          selectedFields={code}
                        />
                      ) : null}
                      {npiCode.length > 0 && !active ? (
                        <ReusableChip
                          chipType="NPI code"
                          handleDeleteSelectedFields={handleDeleteNpiCode}
                          selectedFields={npiCode}
                        />
                      ) : null}
                    </div>
                  </>
                ) : null
              ) : ( */}
              {gridLoad && (
                <>
                  <div style={{ marginTop: '20px', marginBottom: '40px' }}>
                    <SearchFilters
                      active={active}
                      setActive={setActive}
                      name={name}
                      setName={setName}
                      handleSelectName={handleSelectName}
                      code={code}
                      setCode={setCode}
                      handleSelectCode={handleSelectCode}
                      npiCode={npiCode}
                      setNpiCode={setNpiCode}
                      handleSelectNpiCode={handleSelectNpiCode}
                      onFilterSubmit={onFilterSubmit}
                      fileCategory={fileCategory}
                    />
                  </div>
                  <div
                    style={{
                      display: 'flex',
                      marginTop: '80px',
                      // marginBottom: '20px',
                      gap: '8px 8px',
                      flexWrap: 'wrap',
                    }}>
                    {name.length > 0 && !active ? (
                      <ReusableChip
                        chipType="Service name"
                        handleDeleteSelectedFields={handleDeleteName}
                        selectedFields={name}
                      />
                    ) : null}
                    {code.length > 0 && !active ? (
                      <ReusableChip
                        chipType="Billing code"
                        handleDeleteSelectedFields={handleDeleteCode}
                        selectedFields={code}
                      />
                    ) : null}
                    {npiCode.length > 0 && !active ? (
                      <ReusableChip
                        chipType="NPI code"
                        handleDeleteSelectedFields={handleDeleteNpiCode}
                        selectedFields={npiCode}
                      />
                    ) : null}
                  </div>
                </>
              )}
            </Box>
            {priceListData === null ||
            (!fetchPriceListByIdCall.loading && priceListData.length < 1) ? (
              !coverageData.length ? (
                <NotFound priceList={true} title />
              ) : // : link && downloadFlag === 1 ? (
              //   <NotFound
              //     title
              //     download={true}
              //     onOpen={handleOpen}
              //     setHyperlinkClick={setHyperlinkClick}></NotFound>
              // )
              coverageData.length > 1 ? (
                value ? (
                  value && priceListClick ? (
                    <NotFound
                      customText={
                        !value || !priceListClick
                          ? coverageData.length === 1
                            ? null
                            : 'Please select the plan to view price list'
                          : null
                      }
                      title={
                        value && priceListClick
                          ? PRICE_LIST.TITLE_TEXT
                          : coverageData.length === 1
                          ? PRICE_LIST.TITLE_TEXT
                          : null
                      }
                      priceListFlag={true}
                    />
                  ) : (
                    <>
                      {/* {bacShoppingLink.includes('cigna') && (
                        <div>
                          Price comparison tool -{' '}
                          <a href={bacShoppingLink}>Click here</a>
                        </div>
                      )} */}
                      <PriceListSearchBox
                        npiValue={npiCode}
                        setNpiValue={setNpiCode}
                        serviceValue={name}
                        setServiceName={setName}
                        codeValue={code}
                        setCodeValue={setCode}
                        onSubmit={onViewPriceListClick}
                      />
                    </>
                  )
                ) : (
                  <NotFound
                    customText={
                      !value || !priceListClick
                        ? coverageData.length === 1
                          ? null
                          : 'Please select the plan to view price list'
                        : null
                    }
                    title={
                      value && priceListClick
                        ? PRICE_LIST.TITLE_TEXT
                        : coverageData.length === 1
                        ? PRICE_LIST.TITLE_TEXT
                        : null
                    }
                    priceListFlag={true}
                  />
                )
              ) : priceListClick ? (
                <NotFound
                  customText={
                    !value || !priceListClick
                      ? coverageData.length === 1
                        ? null
                        : 'Please select the plan to view price list'
                      : null
                  }
                  title={
                    value && priceListClick
                      ? PRICE_LIST.TITLE_TEXT
                      : coverageData.length === 1
                      ? PRICE_LIST.TITLE_TEXT
                      : null
                  }
                  priceListFlag={true}
                />
              ) : (
                <>
                  {/* <div>
                    Price comparison tool -{' '}
                    <a href={bacShoppingLink}>Click here</a>
                  </div> */}
                  <PriceListSearchBox
                    npiValue={npiCode}
                    setNpiValue={setNpiCode}
                    serviceValue={name}
                    setServiceName={setName}
                    codeValue={code}
                    setCodeValue={setCode}
                    onSubmit={onViewPriceListClick}
                  />
                </>
              )
            ) : (
              <>
                <Box
                  sx={{
                    width: '100%',
                    alignSelf: 'center',
                    mt: 2,
                    pb: 2,
                  }}>
                  <CoveragePLTableAndSeach
                    tableHeading={tableHeading}
                    data={priceListTableData}
                    onItemView={onItemView}
                  />
                </Box>
                <div style={paginationStyle}>
                  <Pagination
                    count={pageNumbers}
                    page={currentPage}
                    variant="outlined"
                    color="primary"
                    onChange={(event, value) => setCurrentPage(value)}
                  />
                </div>
              </>
            )}
          </TabContext>
        </Box>
        <SimpleBackdrop
          open={fetchPriceListByIdCall.loading || loading || isLoading}
        />
      </Box>
      <PriceListConfirmationModal
        open={open}
        onClose={handleClose}
        heading="Warning"
        description={ACTIVE_PRICE_LIST_PAGE.DownloadDescription}
        warning={ACTIVE_PRICE_LIST_PAGE.DownloadWarning}
        proceedDownloadClick={proceedDownloadClick}
      />
      <PriceListFlyout
        serviceName={flyoutData?.serviceName}
        billingCode={flyoutData?.billingCode}
        providersNpi={flyoutData?.providersNpi}
        codingSystemVersion={flyoutData?.codingSystemVersion}
        entityName={flyoutData?.entityName}
        entityType={flyoutData?.entityType}
        expirationDate={flyoutData?.expirationDate}
        lastUpdatedOn={flyoutData?.lastUpdatedOn}
        negotiatedArrangement={flyoutData?.negotiatedArrangement}
        planIdType={flyoutData?.planIdType ? flyoutData.planIdType : 'out-of-network'}
        planName={coverageData[0]?.name}
        planId={coverageData[0]?.priceListId}
        derivedTin={flyoutData?.tin}
        negotiatedType={flyoutData?.negotiatedType}
        handleClose={closeFlyout}
        isOpen={openFlyout}
        modifier={modifier}
        setModifier={setModifier}
        modifierMenu={modifierMenu}
        setModifierMenu={setModifierMenu}
        tabValue={tabValue}
      />
    </>
  );
};

export default ActivePlansPriceList;
